import { getCustomHeaders } from '@/components/marketing-landing-page/utils';
import apiClient from '@/lib/auth.client';
import { BatchDetailModel } from '@/types/batch';
import { Country } from '@/types/types';

const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL_AUTH;
const cjrBaseUrl = process.env.NEXT_PUBLIC_CJR_API_BASE_URL;

// Lazy initialization to avoid circular dependency issues
const getHeaders = () => getCustomHeaders({ org: 'CJR' });

// Cache for country data to prevent duplicate API calls
let countryCache: { data: Country[] } | null = null;
let countryPromise: Promise<{ data: Country[] }> | null = null;

export const getCountryList = async () => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  // Return cached data if available
  if (countryCache) {
    return countryCache;
  }

  // Return existing promise if already in progress
  if (countryPromise) {
    return countryPromise;
  }

  // Create new API call
  countryPromise = apiClient.get<{ data: Country[] }, unknown>(`${cjrBaseUrl}/v1/public/country`, {
    customHeaders: getHeaders(),
    public: true,
  });

  try {
    const result = await countryPromise;
    countryCache = result;
    return result;
  } finally {
    countryPromise = null;
  }
};

export const getBatchDetails = async (batchId: string) => {
  return apiClient.get<{ data: BatchDetailModel }, unknown>(
    `${baseUrl}/v3/batches/${batchId}/details`,
    {
      customHeaders: getHeaders(),
      public: true,
    }
  );
};

export const updateCjrProfile = ({ pwPro, grade }: { pwPro: boolean; grade: string }) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return apiClient.put(
    `${cjrBaseUrl}/v1/user/profile`,
    {
      pwPro,
      grade,
    },
    { customHeaders: getHeaders() }
  );
};
